import styled from 'styled-components';
import { spacing, colors } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const ContentContainer = styled.div`
  display: flex;
`;

export const VisualizationsPanelContainer = styled.div`
  flex: 1 1 50%;
  padding: ${spacing.base};
  border-right: ${spacing.single} solid ${colors.grey25};
`;

export const SettingsPanelContainer = styled.div`
  padding: ${spacing.base};
  flex: 1 1 50%;
  min-height: ${pxToRem(400)};
  overflow-x: hidden;
`;

export const SettingsMessageContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.half};
`;
